module.exports = __webpack_public_path__ + "img/person-headest.aa05eba.svg";